import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import {
  Bubble,
} from "tea-component";
import { SortBy } from 'tea-component/es/table/addons';
import { useIntl, getLocale, useDispatch, connect } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import HeatMapTable, {
  HeatCellDataStruct,
  creatHeatColumns,
  HeatMapTableColumn,
  DATE_COLUMN
} from '@/pages/dashboard/components/HeatMapTable';
import Accumulate, { SEPARATED_OPTIONS } from '@/pages/dashboard/components/Accumulate';
import MetricAndUpDown from '@/pages/dashboard/components/MetricAndUpDown';
import TrackingDay from '@/pages/dashboard/components/TrackingDay';
import { formatNum, formatPercentNum, getDateWeekDayStr, getUpAndDownStatus, toUpperFirstCase } from '@/pages/dashboard/utils/utils';
import { useLocal, useSelectArrObj } from '@/pages/dashboard/utils/customHook';
import { downloadFileWithFileFormat, useNotificationOfDownloadTable } from "@/pages/dashboard/components/DownloadFormatModal";
import { getExplainVal } from '@/pages/dashboard/utils/getExplainVal';
import { downLoadApi } from '@/pages/dashboard/services/common';
import { LANGUAGE_MAP, MATCH_ROUTE_REG } from '@/pages/dashboard/_config/constant';
import useData from './useData';
import { findPageSelector } from '@/pages/dashboard/components/NewFilter/util';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import dateTimeFormat from '@home/utils/dbDataFormat/dateTimeFormat';
/**
 *  表格请求参数
 */
interface TableReqParams {
  game_code: string; // 游戏码,根据游戏吗取对应游戏的数据
  start_time: string; // 开始时间,参数示例:2022-01-02
  end_time: string; // 结束时间,参数示例:2022-01-02
  filters: {
    zone_list: string[]; // 游戏区服,多选,参数示例:[1,2,3]
    market_list: string[]; // 地区类型,参数示例:region
    os_list: string[]; // 玩家操作平台,多选,参数示例:[1,2,3]
    channel_list: string[]; // 渠道标识,多选,参数示例:[3]
    lang_list: string[];
  };
  accumulation: object; // 维度筛选器
  sorted_by: string; // 排序指标名称
  desc: boolean; // 【选填】是否降序列
  track_days: string[]; // 追踪天数
  page_size: number; // 每页数量，参数示例：10
  page: number; // 页码，参数示例：1,
  period: "daily" | "weekly" | "monthly";
}

const TableLevelCo = (props: any) => {
  const { config, style, className, gameConfig, dataFrame, gameCode = '', explainInfo } = props;
  const contextObj = useContext(FilterContext);
  const { filterLoading, filterVal = {} } = contextObj || {};
  const { title, titleCN, componentMetrics, defaultMetrics, keyDaysConfig, api: { tableDownloadApi }, height, titleDes: titleDesConfig } = config;
  const { formatMessage } = useIntl();
  const { isEN } = useLocal();
  let selectOptions = useSelectArrObj(filterVal);
  selectOptions = selectOptions?.filter(i => i?.groupKey === 'separated');
  selectOptions.unshift({
    groupKey: 'separated',
    value: 'date',
    text: formatMessage({ id: 'common_by_Date' }),
    disabled: true,
  });
  const [columns, setColumns] = useState([{ features: { sortable: false } }]); // 默认值是为了解决控制台warning, 无功能作用
  const [tableData, setTableData] = useState([]);
  const [tableCopyData, setTableCopyData] = useState([]);
  // Accumulated 筛选器
  const [accumulated, setAccumulated] = useState<string[]>(['date']);
  // 排序值
  const [sortValue, setSortValue] = useState<SortBy[]>([]);
  // 表格分页记录
  const [tablePaging, setTablePaging] = useState({ pageIndex: 1, pageSize: 10 });
  const [total, setTotal] = useState(0);
  const [trackDays, setTrackDays] = useState(keyDaysConfig);
  const [isHover, setIsHover] = useState(false);

  const accumulateOldValueRef = useRef(['date']);
  const dispatch = useDispatch();

  const paramsFilter = useCallback(
    (params: { filters: { [x: string]: any; }; accumulation: { [x: string]: any; }; }) => {
      const {
        default_selector: defaultSelector = [],
        page_selector: pageSelector = [],
      } = gameConfig || {};
      const fieldMap: any = {
        zone: {
          filter: 'zone_list',
          accumulation: 'by_zone',
        },
        region: {
          filter: 'market_list',
          accumulation: ['by_region', 'by_country'],
        },
        channel: {
          filter: 'channel_list',
          accumulation: 'by_channel',
        },
        system: {
          filter: 'os_list',
          accumulation: 'by_system',
        },
        lang: {
          filter: 'lang_list',
          accumulation: 'by_language',
        },
        language: {
          filter: 'lang_list',
          accumulation: 'by_language',
        },
        bundle: {
          filter: 'bundle_list',
          accumulation: 'by_bundle',
        }
      };
      const visibleList = findPageSelector(
        location.pathname.replace(MATCH_ROUTE_REG, '/'),
        pageSelector,
        defaultSelector,
        dataFrame
      )?.map((item: any) => fieldMap[item?.key]);

      const newFilter = (() => {
        const filter: {
          [key: string]: any;
        } = Object.keys(params?.filters || {}).reduce((acc, key) => {
          if (visibleList?.some(item => item?.filter === key)) {
            acc[key] = params.filters[key];
          }
          return acc;
        }, {}) || {};
        return filter;
      })();

      const newAccumulation = (() => {
        const accumulation: {
          [key: string]: any;
        } = Object.keys(params?.accumulation || {}).reduce((acc, key) => {
          if (visibleList?.some(item => item?.accumulation === key || item?.accumulation?.includes?.(key))) {
            acc[key] = params.accumulation[key];
          }
          return acc;
        }, {}) || {};
        return Object.keys(accumulation).length > 0 ? accumulation : null;
      })();
      const filterIsNullFlag = JSON.stringify(newFilter) == '{}';
      const hasAccumulation = Boolean(params?.accumulation);

      const result = {
        ...params,
        filters: newFilter,
        accumulation: newAccumulation,
      };

      !hasAccumulation && delete result.accumulation;
      filterIsNullFlag && delete result.filters;
      return result;
    },
    [gameConfig],
  );
  
  const churnUsersData = useData(config, filterVal, filterLoading, trackDays, accumulated, paramsFilter, dispatch, setTablePaging, setSortValue);

  const {
    componentData,
    getRetentionDataFunc,
    error,
    loading,
  } = churnUsersData;
  const tableTitle = useMemo(() => isEN ? title : titleCN, [isEN, title, titleCN]);
  const { setNoticeStatus } = useNotificationOfDownloadTable(tableTitle);

  useEffect(() => {
    const { Rows = [], level_count = 0, row_count } = componentData || {};
    setColumns([...getNormalColumns, ...getHeatColumns(level_count)]);
    setTableData(handleTableData(Rows, false) || []);
    setTableCopyData(handleTableData(Rows, true) || []);
    setTotal(row_count || 0);
  }, [componentData, getLocale()]);


  // 非热力的列
  const getNormalColumns = useMemo(()=> {
    // 日期列配置
    const dateColumn = {
      ...DATE_COLUMN,
      name: formatMessage({ id: 'engagement_churn_Register_Date' }),
      width: 160,
      align: 'left',
      lock: true,
      render: (date) => {
        const { weekStr, isSunOrSat } = getDateWeekDayStr(date, formatMessage);
        const isMonth = filterVal?.timeType === 'Month';
        return <>
          <span>{date}</span>
          {
            !isMonth && <span className={isSunOrSat ? 'text-week-b' : 'text-week'}>{weekStr}</span>
          }
        </>;
      }
    };

    // accumulate列配置
    const accumulateColumns: { code: string; width: number; align: string; name: string; features: { sortable: boolean; }; }[] = [];
    accumulated.filter(ele => ele !== 'date').forEach((val) => {
      const option = SEPARATED_OPTIONS.find((opt) => opt.value === val);
      option && accumulateColumns.push({
        code: val,
        width: 120,
        align: 'left',
        name: formatMessage({ id: `common_${toUpperFirstCase(option?.value)}` }),
        features: { sortable: true },
      });
    });

    const METRICS_COLUMN = componentMetrics?.map((metrics)=>{
      const { title, titleCn, code, width, align, features } = metrics || {};
      return {
        code,
        width,
        title: isEN ? title : titleCn,
        align,
        features,
        render: ({ value, dod, status }) => (
          <MetricAndUpDown
            metric={value}
            updown={{ data: dod, status }}
          />
        ),
      };
    }) || [];

    const DEFAULT_COLUMN = defaultMetrics?.map((metrics)=>{
      const { title, titleCn, code, width, align, features } = metrics || {};
      return {
        code,
        width,
        title: isEN ? title : titleCn,
        align,
        features
      };
    }) || [];
    return [dateColumn, ...accumulateColumns, ...METRICS_COLUMN, ...DEFAULT_COLUMN];
  },[accumulated, componentMetrics, defaultMetrics, filterVal, isEN]);

  // 根据接口获取热力图列
  const getHeatColumns = (count = 0) => {

    const heatColumns: HeatMapTableColumn[] = [];
    for (let i = 1;i <= count;i++) {
      heatColumns.push({
        code: `l${i}`,
        name: `L${i}`,
      });
    }
    return creatHeatColumns(heatColumns);
  };

  /** 返回数据格式整理 */
  const handleTableData = (data: any[] = [], isCopy: boolean) => data?.map(({ date, registered_users, level_list = [], tracking_day, ...accumulateValue } = {}) => {
    date = dateTimeFormat(date,'YYYY-MM-DD');
    // 计算 Accumulate筛选器的动态列的数据
    const localeCode = getLocale() === 'zh-CN' ? 'cn' : 'en';
    const accumulatedData = {};
    accumulated.filter(ele => ele !== 'date').map((value) => {
      accumulatedData[value] = accumulateValue?.dimension_name?.[`${value}_name_${localeCode}`] || "-";
    });
    // 计算 热力列的 数据
    const metricsObj: HeatCellDataStruct = {};
    level_list?.forEach((metric, index) => {
      const key = `l${index + 1}`;
      let { value = '', dod = '' } = metric;
      value = isCopy ? value : formatNum(value, false, true);
      const colorPercent = Number(dod) || 0;
      dod = isCopy ? dod : formatPercentNum(dod);
      metricsObj[key] = {
        bubble: {
          content: (<>
            <span className='table-bubble-date'>{date}</span>
            <div className='table-bubble-info'>
              <span className="Revenue-table-Lspan">Churn Users</span>
              <span className='Revenue-table-Rspan'>{value}</span>
            </div>
            <div className='table-bubble-info'>
              <span className="Revenue-table-Lspan">Churn %</span>
              <span className='Revenue-table-Rspan'>{dod}</span>
            </div>
          </>)
        },
        cellContent: dod,
        colorPercent,
      };
    });
    return {
      date,
      ...accumulatedData,
      register: {
        value: isCopy ? registered_users?.value : formatNum(registered_users?.value, false, true),
        dod: isCopy ? registered_users?.dod : formatPercentNum(parseFloat(registered_users?.dod), 1, true),
        status: isCopy ? registered_users?.dod : getUpAndDownStatus(registered_users?.dod)
      },
      tracking_day,
      ...metricsObj,
    };
  });

  // 获取 获取上传参数对象
  const getTableReqParams = (paging, sort): TableReqParams => {
    const { rangeTime, channel, region, system, zone, lang: language } = filterVal;
    const accumulation = {
      by_zone: accumulated.includes('zone'),
      by_region: accumulated.includes('region'),
      by_country: accumulated.includes('country'),
      by_channel: accumulated.includes('channel'),
      by_system: accumulated.includes('system'),
      by_language: accumulated.includes('language'),
      by_bundle: accumulated.includes('bundle'),
    };
    const desc = sort[0] ? sort[0]?.order === 'desc' : true;
    const sorted_by = sort[0]?.code || 'date';
    return {
      game_code: gameCode,
      start_time: dateTimeFormat(rangeTime[0],'YYYY-MM-DD'),
      end_time: dateTimeFormat(rangeTime[1],'YYYY-MM-DD'),
      period: 'daily',
      filters: {
        channel_list: channel,
        market_list: region?.markets,
        os_list: system,
        zone_list: zone,
        lang_list: language,
        bundle_list: filterVal?.bundle,
      },
      accumulation,
      desc,
      sorted_by,
      page: paging.pageIndex,
      page_size: paging.pageSize,
      track_days: trackDays,
    };
  };

  /**
   * 下载文件
   */
  const download = () => {
    const downloadPromise = downPromise?.();
    if (downloadPromise instanceof Promise) { // 有返回Promise对象时由内部处理下载过程
      // 展示正在下载中通知
      setNoticeStatus("loading");
      // 发起请求下载
      (async () => {
        try {
          const res = await downloadPromise;
          const fileName = `${tableTitle.replace(/\u0020/g, '_')} ${moment().format('YYYY_MM_DD HH_mm_ss')}`;
          await downloadFileWithFileFormat(res, fileName, {
            onDownloadSuccess() {
              setNoticeStatus("success");
            },
            onDownloadError() {
              setNoticeStatus("error");
            }
          });
        } catch (e) {
          setNoticeStatus("error");
        }
      })();
    }
  };

  function downPromise() {
    const params: TableReqParams = getTableReqParams(tablePaging, sortValue);
    const language = LANGUAGE_MAP[getLocale()];
    return downLoadApi?.(`${tableDownloadApi}?language=${language}`, params);
  }

  const titleDes = titleDesConfig?.map((val)=> {
    const explain = getExplainVal(explainInfo, val?.rainbowKey, getLocale(), val?.explainEn, val?.explainCn);
    const content = isEN ? val.contentEn : val.contentCn;
    return {
      title: isEN ? val.title : val.titleCn,
      content: val.isRainbow ? explain : content
    };
  });

  return (
    <div className={`dbd-retention-table-co ${className || ''}`} style={style}>
      <HeatMapTable
        timeType={filterVal?.timeType}
        title={
          <>
            {tableTitle}
            {
              titleDes && titleDes?.length > 0 && (
                <Bubble
                  className='register-table-tipWidth'
                  dark
                  content={
                    <>
                      {
                        titleDes?.map((title: any, index: number) => (
                          <p
                            key={index}
                            dangerouslySetInnerHTML={{
                              __html: `
                                  ${title?.title ? `${title?.title?.replace(/\\n/g, '<br/>')  }<br/>` : ''}
                                  ${title.content?.replace(/\\n/g, '<br/>')}
                              `
                            }}
                            style={{
                              marginTop: index !== 0 ? '24px': '0'
                            }}
                          />
                        ))
                      }
                    </>
                  }
                >
                  <i
                    onMouseOver={()=>{setIsHover(true)}}
                    onMouseOut={()=>{setIsHover(false)}}
                    className='register-table-tip'
                  >
                    <SvgIcon
                      type={isHover?'alert-circle-action':'alert-circle-m'}
                      className='register-table-tipicon'
                    />
                  </i>
                </Bubble>
              )
            }
          </>
        }
        records={tableData}
        copyData={tableCopyData}
        defaultColumnWidth={50}
        height={height || 760}
        columns={columns}
        sorting={{
          sorts: sortValue,
          onChangeSorts: (nextSorts) => {
            setSortValue(nextSorts);
            getRetentionDataFunc(accumulated, nextSorts, tablePaging, trackDays);
          },
        }}
        paging={{
          recordCount: total,
          pageSize: tablePaging.pageSize,
          pageIndex: tablePaging.pageIndex,
          onPagingChange: (pagingQuery) => {
            setTablePaging(pagingQuery);
            getRetentionDataFunc(accumulated, sortValue, pagingQuery, trackDays);
          },
          pageSizeOptions: [10, 20, 30, 50],
          stateText: total > 10 ? `${total} ${formatMessage({ id: 'common_records' })}` : '',
        }}
        loading={filterLoading || loading}
        error={error}
        onDownload={download}
        topTip={
          {
            left: (<>
              <Accumulate
                className='register-table-select'
                value={accumulated}
                selectOptions={selectOptions}
                onChange={(value) => {
                  setAccumulated(value);
                }}
                onClose={() => {
                  if (accumulateOldValueRef?.current?.toString() == accumulated?.toString()) {
                    return;
                  }
                  accumulateOldValueRef.current = accumulated;
                  // 分页和排序重置
                  setTablePaging({ pageIndex: 1, pageSize: 10 });
                  setSortValue([]);
                  getRetentionDataFunc(accumulated, [], { pageIndex: 1, pageSize: 10 }, trackDays);
                }}
              />
              { 
                filterVal?.timeType === 'Day' && (
                  <TrackingDay
                    value={trackDays}
                    keyDaysValue={keyDaysConfig}
                    onChange={(value) => {
                      setTrackDays(value);
                      getRetentionDataFunc(accumulated, sortValue, tablePaging, value);
                    }}
                  />
                )
              }
            </>)
          }
        }
      />
    </div>
  );
};

export default connect((state: any) => ({
  gameConfig: state.dashboardSetting.gameConfig,
  dataFrame: state.dashboard?.currentGame?.data_frame || 'mobile',
  gameCode: state.dashboard?.currentGame?.game_code,
  explainInfo: state.dashboard?.explainInfo,
}))(TableLevelCo);
